import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FullPetDetailsPropTypes } from '../../../../propTypes/petDetails';
import { ReimbursementPopup } from '../../../payments/reimbursementPopup/reimbursementPopup';
import { SuccessMessageDialog } from '../../../successMessage/successMessageDialog';
import { maskBankInfo } from '../../../../utils/maskDetails';
import { SLICES } from '../../../../constants/slices';
import { REIMBURSEMENT, SUCCESS_MESSAGES } from '../../../../constants/constants';
import { singlePetSuccessMessage } from '../../../../utils/successMessages';

export const ClaimReimbursement = ({ isReadOnly, activePet, hasReimbursementDetails }) => {
  const [isBankDetailsPopupActive, setIsBankDetailsPopupActive] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState({ active: false, isApplyToAllPetChecked: false });
  const { newReimbursementDetails } = useSelector((state) => state?.[SLICES.CLAIMS].reimbursementDetails);

  const {
    PolicyDetails: {
      ReimbursementInfo: { accountNumber, accountHolderName }
    }
  } = activePet;

  const handleBankDetailsPopupTrigger = () => {
    setIsBankDetailsPopupActive(true);
  };

  return (
    <fieldset>
      <h3>Provide your reimbursement account details.</h3>
      <p>
        {(accountNumber && accountHolderName) ||
        (newReimbursementDetails?.newAccountNumber && newReimbursementDetails?.newAccountHolderName)
          ? REIMBURSEMENT.WITH
          : REIMBURSEMENT.WITHOUT}
      </p>
      {!hasReimbursementDetails &&
        !newReimbursementDetails?.newAccountNumber &&
        !newReimbursementDetails?.newAccountHolderName && (
          <span
            className="custom_validation"
            id="reimbursementDetails_custom_errors"
          >
            <span className="error">Please provide your bank details.</span>
          </span>
        )}
      {((accountNumber && accountHolderName) ||
        (newReimbursementDetails?.newAccountNumber && newReimbursementDetails?.newAccountHolderName)) && (
        <>
          <p>Account Name : {newReimbursementDetails?.newAccountHolderName || accountHolderName}</p>
          <p>
            Bank Account :{' '}
            {newReimbursementDetails?.newAccountNumber
              ? maskBankInfo(newReimbursementDetails?.newAccountNumber)
              : maskBankInfo(accountNumber)}
          </p>
        </>
      )}
      {!isReadOnly && (
        <div>
          <button
            type="button"
            className="button primary"
            onClick={handleBankDetailsPopupTrigger}
          >
            <span className="labelText">
              {!accountNumber && !accountHolderName ? 'Add bank details' : 'Update bank details'}
            </span>
          </button>
        </div>
      )}

      {isBankDetailsPopupActive && (
        <ReimbursementPopup
          activePet={activePet}
          onCancel={() => setIsBankDetailsPopupActive(false)}
          setShowSuccessMessage={setShowSuccessMessage}
        />
      )}

      {showSuccessMessage.active && (
        <SuccessMessageDialog
          message={`${singlePetSuccessMessage()}${
            showSuccessMessage.isApplyToAllPetChecked ? SUCCESS_MESSAGES.MULTI_PET : ''
          }`}
          onClose={() => setShowSuccessMessage(false)}
        />
      )}
    </fieldset>
  );
};

ClaimReimbursement.propTypes = {
  isReadOnly: PropTypes.bool,
  activePet: FullPetDetailsPropTypes,
  hasReimbursementDetails: PropTypes.bool
};
